import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import format from './format';
import enUS from './translations/en-US/translations.json';
import ptBR from './translations/pt-BR/translations.json';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n.use(initReactI18next).init({
  resources: { 'en-US': enUS, 'pt-BR': ptBR },
  fallbackLng: 'en-US',
  lng: undefined,
  returnNull: false,
  interpolation: {
    escapeValue: false,
    format,
  },
  // This prevents the key names from displaying in place of values before language is set
  parseMissingKeyHandler: () => '',
});

export default i18n;
